var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTiers = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 32,
  height: 32,
  fill: "none",
  "aria-hidden": "true",
  viewBox: "0 0 32 32"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#1F2124",
  d: "M14 4v7a1 1 0 1 1-2 0V5a1 1 0 0 0-1-1H5a1 1 0 0 1 0-2h7a2 2 0 0 1 2 2"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#1F2124",
  fillRule: "evenodd",
  d: "m2.293 12.293 9.5-9.5 1.414 1.414-9.5 9.5a1 1 0 0 1-1.414-1.414",
  clipRule: "evenodd"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#1F2124",
  d: "M29 0a3 3 0 0 1 3 3v26a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3v-6a3 3 0 0 1 3-3h7v-3a3 3 0 0 1 3-3h7V3a3 3 0 0 1 3-3zM3 22a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h7v-8zm10-6a1 1 0 0 0-1 1v13h8V16zM23 2a1 1 0 0 0-1 1v27h7a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1z"
})));
export default SvgTiers;